var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
    [_vm.$style.footer]: true,
    [_vm.$style.footerFullWidth]: _vm.settings.isContentNoMaxWidth,
  }},[_c('div',{class:_vm.$style.inner},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"logo-rodape",class:_vm.$style.logo},[_vm._m(0)])])])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('a',{attrs:{"href":"https://acquire.solutions","title":"Acquire - Plataforma Para Gestão de Recebíveis!","target":"_blank"}},[_c('img',{attrs:{"src":"resources/images/logo.png","alt":"Acquire Solutions"}})])
}]

export { render, staticRenderFns }